import {HOMEWARE} from "../../config/constants"

export function isHomewareDepartment(department: string) {
    return department?.toLowerCase() === HOMEWARE
}
